<template lang="pug">
el-container
  el-header.header
    .logo
      img(src="/logo.jpg")
    .profile
      .profile-img
        | {{profileFirstStr}}
      el-dropdown(trigger="click" @visible-change="ProfileDropChange" @command="CommandHandle")
        span.el-dropdown-link
          | {{(userInfo || {}).username }}
          i(:class="profileState ? 'el-icon-arrow-down' : 'el-icon-arrow-right'")
        el-dropdown-menu(slot="dropdown")
          el-dropdown-item(icon="el-icon-plus" command="my")
            | 个人中心
          el-dropdown-item(icon="el-icon-circle-plus" command="logout")
            span 退出
    
  el-container.content
    el-aside
      el-menu(
        :router="true" 
        :default-active="activeName"
        background-color="#24292e"
        text-color="#fff"
        active-text-color="#ffd04b"
        )
        el-menu-item(v-for="(menu,index) of sidebar" :key="index" :index="menu.name" :route="menu" v-power:[menu.meta.power])  {{menu.meta.title}}
    el-container
      el-main
        router-view
</template>

<script>
import {routes} from '../router'
import config from '../../local_env.json'

export default {
    data() {
        const sidebar = routes.find((r) => {
            return r.name === 'home'
        }).children
        return {
          config,
          sidebar,
          profileState: false
        }
    },
    computed: {
      activeName() {
        return this.$route.name
      },
      userInfo() {
        return this.$store.state.userInfo
      },
      profileFirstStr () {
        if (!this.userInfo) return ''
        return this.userInfo.nickname.substring(0, 1)
      }
    },
    methods: {
      ProfileDropChange(state) {
        this.profileState = state
      },
      CommandHandle(command) {
        switch(command) {
          case 'logout':
            this.Logout()
            break
          case 'my':
            this.$router.push({name: 'my'})
            break
          default: 
            break
        }
      },
      Logout() {
        this.$store.commit('logout')
        this.$router.push({name: 'login'})
      }
    }
}
</script>


<style lang="less" scoped>
  .el-header {
    background-color: white;
    color: #333;
    text-align: center;
    line-height: 60px;
    padding: 0px;
  }
  
  .el-aside {
    background-color: #24292e;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    // padding: 10px;
    // padding-bottom:70px;
  }

  .el-container.content {
      position:absolute;
      top: 60px;
      bottom: 0px;
      left: 0px;
      right:0px;
  }

  .header {
    position: absolute;
    width: 100%;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e6e6e6;

    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 299px;
    }

    .profile {
      width: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-dropdown-link {
        &:hover {
          cursor: pointer;
        }
      }
      .image {
        border-radius: 25px;
        width: 45px;
        height: 45px;
        margin-right:10px;
      }
      .profile-img {
        border-radius: 25px;
        width: 45px;
        height: 45px;
        margin-right: 10px;
        background-color: #409eff;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 20px;
      }
    }
  }

  .el-footer {
    position: absolute;
    bottom: 0px;
    left: 300px;
    right: 0px;
    background-color: white;
    color: #333;
    line-height: 60px;
    border-top: 1px solid #e6e6e6;
  }
</style>